import feathersClient, {
	makeServicePlugin,
	BaseModel
} from '../feathers-client.js'

class Purchases extends BaseModel {
	// eslint-disable-next-line no-useless-constructor
	constructor(data, options) {
		super(data, options)
	}

	// Required for $FeathersVuex plugin to work after production transpile.
	static modelName = 'Purchases'

	// Define default properties here
	static instanceDefaults() {
		return {
			userId: '',
			listId: '',
			_v: '',
			_id: ''
		}
	}
}

const servicePath = 'purchases'
const servicePlugin = makeServicePlugin({
	Model: Purchases,
	service: feathersClient.service(servicePath),
	servicePath,
	skipRequestIfExists: true,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
	before: {
		all: [],
		find: [],
		get: [],
		create: [],
		update: [],
		patch: [],
		remove: []
	},
	after: {
		all: [],
		find: [],
		get: [],
		create: [],
		update: [],
		patch: [],
		remove: []
	},
	error: {
		all: [],
		find: [],
		get: [],
		create: [],
		update: [],
		patch: [],
		remove: []
	}
})

export default servicePlugin
